import BackButton from '@/components/back-button/back-button';
import { DecisionTree, OnItemViewedCB, UseSetupCallbackCB, UserQuestionnaireType } from '@/components/decision-tree';
import Layout from '@/components/layout-questionnaire/layout-questionnaire';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';

type QuestionnaireProps = {
  userQuestionnaire: UserQuestionnaireType;
  decisionTreeCallback: UseSetupCallbackCB;
  onItemViewed?: OnItemViewedCB;
  backOnFirstSurveyItem: () => void;
};

export default function Questionnaire({
  userQuestionnaire,
  decisionTreeCallback,
  onItemViewed,
  backOnFirstSurveyItem,
}: QuestionnaireProps) {
  return (
    <Layout background="background-page">
      <DecisionTree
        userQuestionnaire={userQuestionnaire}
        callback={decisionTreeCallback}
        onItemViewed={onItemViewed}
        backOnFirstSurveyItem={backOnFirstSurveyItem}
        header={(props) => (
          <NavigationBar
            leftContent={props.showBackButton && props.onBackClick ? <BackButton onClick={props.onBackClick} /> : null}
            beta
          />
        )}
      />
    </Layout>
  );
}
